// src/layouts/DashboardLayout.jsx
import { Outlet } from "react-router-dom";
import SidebarLayout from "../../components/common/layout/SidebarLayout";

const DashboardLayout = () => {
  return (
    <SidebarLayout
      title=""
      base=""
      sections={[]}
      isopen={true}
      enableToggle={true}
    >
      <Outlet />
    </SidebarLayout>
  );
};

export default DashboardLayout;
